const templateUrl = require('./remove-item.html');

module.exports = {
  bindings: {
    item: '<ogFor'
  },
  controller: 'RemoveItemController',
  templateUrl: templateUrl
};
